import { render, staticRenderFns } from "./page-17.vue?vue&type=template&id=2a32f8ce&scoped=true&"
import script from "./page-17.vue?vue&type=script&lang=js&"
export * from "./page-17.vue?vue&type=script&lang=js&"
import style0 from "./page-17.vue?vue&type=style&index=0&id=2a32f8ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a32f8ce",
  null
  
)

export default component.exports